import { render } from "./ATrustedPartner.vue?vue&type=template&id=ab8cbd84"
import script from "./ATrustedPartner.vue?vue&type=script&lang=js"
export * from "./ATrustedPartner.vue?vue&type=script&lang=js"

import "./ATrustedPartner.vue?vue&type=style&index=0&id=ab8cbd84&lang=css"

import exportComponent from "D:\\wamp64\\www\\safest\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__